import script from "./BodySubSecurityTemplate.vue?vue&type=script&setup=true&lang=js"
export * from "./BodySubSecurityTemplate.vue?vue&type=script&setup=true&lang=js"

const cssModules = {}
import style0 from "./BodySubSecurityTemplate.vue?vue&type=style&index=0&id=f6236a8c&module=securityTemplate&lang=css"
cssModules["securityTemplate"] = style0
import "./BodySubSecurityTemplate.vue?vue&type=style&index=1&id=f6236a8c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__cssModules',cssModules],['__scopeId',"data-v-f6236a8c"]])

export default __exports__
import QImg from 'quasar/src/components/img/QImg.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QImg});
